"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.some.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.string.trim.js");

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    staticClass: "el-upload-dragger",
    "class": {
      'is-dragover': _vm.dragover
    },
    attrs: {},
    on: {
      "drop": function drop($event) {
        $event.preventDefault();
        return _vm.onDrop($event);
      },
      "dragover": function dragover($event) {
        $event.preventDefault();
        return _vm.onDragover($event);
      },
      "dragleave": function dragleave($event) {
        $event.preventDefault();
        _vm.dragover = false;
      }
    }
  }, [_vm._t("default", null, {})], 2);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElUploadDrag',
  props: {
    disabled: Boolean
  },
  inject: {
    uploader: {
      "default": ''
    }
  },
  data: function data() {
    return {
      dragover: false
    };
  },
  methods: {
    onDragover: function onDragover() {
      if (!this.disabled) {
        this.dragover = true;
      }
    },
    onDrop: function onDrop(e) {
      if (this.disabled || !this.uploader) return;
      var accept = this.uploader.accept;
      this.dragover = false;

      if (!accept) {
        this.$emit('file', e.dataTransfer.files);
        return;
      }

      this.$emit('file', [].slice.call(e.dataTransfer.files).filter(function (file) {
        var type = file.type,
            name = file.name;
        var extension = name.indexOf('.') > -1 ? ".".concat(name.split('.').pop()) : '';
        var baseType = type.replace(/\/.*$/, '');
        return accept.split(',').map(function (type) {
          return type.trim();
        }).filter(function (type) {
          return type;
        }).some(function (acceptedType) {
          if (/\..+$/.test(acceptedType)) {
            return extension === acceptedType;
          }

          if (/\/\*$/.test(acceptedType)) {
            return baseType === acceptedType.replace(/\/\*$/, '');
          }

          if (/^[^\/]+\/[^\/]+$/.test(acceptedType)) {
            return type === acceptedType;
          }

          return false;
        });
      }));
    }
  }
};
exports["default"] = _default;